import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Login.css";
import Logo from "../image/LogoSenaGestor.png";

const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPass, setShowPass] = useState(false);

  const onChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("token", "fake-token");
    navigate("/inicio", { replace: true });
  };

  return (
    <div className="creative-login">
      <div className="creative-bg-blur" />

      <div className="creative-card">
        <div className="creative-left">
          <div className="creative-logo-container">
            <img src={Logo} alt="Mr Gestor" />
            <p>Sistema Integral de Gestión Documental & Académica</p>
          </div>

          <div className="creative-features">
            <div>✔ Gestión institucional</div>
            <div>✔ Control de instructores y aprendices</div>
            <div>✔ Reportes y seguimiento</div>
          </div>
        </div>

        <div className="creative-right">
          {/* ✅ Logo SOLO en responsive */}
          <div className="creative-mobile-brand">
            <div className="creative-mobile-logo">
              <img src={Logo} alt="Mr Gestor" />
            </div>
          </div>

          <h3>Bienvenido</h3>
          <p>Ingresa tus credenciales para continuar</p>

          <form onSubmit={handleSubmit}>
            <div className="mb-2">
              <label>Correo</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={onChange}
                placeholder="nombre@correo.com"
                required
              />
            </div>

            <div className="mb-3">
              <label>Contraseña</label>
              <div className="password-wrapper">
                <input
                  type={showPass ? "text" : "password"}
                  name="password"
                  value={form.password}
                  onChange={onChange}
                  placeholder="••••••••"
                  required
                />
                <span onClick={() => setShowPass(!showPass)}>
                  {showPass ? "Ocultar" : "Ver"}
                </span>
              </div>
            </div>

            <button type="submit" className="creative-btn">
              Ingresar al sistema
            </button>
          </form>

          <div className="creative-footer">
            <strong>iCS - Ingenieria Colombianas de Systemas</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;